// Runtime configuration, so one built image can serve several environments.
//
// Resolution order for a setting:
//   1. window.__APP_CONFIG__  - public/config.js, rendered by the container
//      entrypoint from environment variables at start-up
//   2. process.env.REACT_APP_* - baked in at build time (local development)
//   3. the default passed by the caller
export const DEFAULT_API_URL = "https://dev.api.coe.bmte.vn";

const runtimeConfig = () =>
  (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

export const resolveSetting = (runtimeKey, buildTimeValue, fallback) => {
  const runtimeValue = runtimeConfig()[runtimeKey];
  if (typeof runtimeValue === "string" && runtimeValue.trim() !== "") {
    return runtimeValue.trim();
  }
  if (typeof buildTimeValue === "string" && buildTimeValue.trim() !== "") {
    return buildTimeValue.trim();
  }
  return fallback;
};

export const resolveApiUrl = () =>
  resolveSetting("API_URL", process.env.REACT_APP_API, DEFAULT_API_URL);
